import type { IReviewItem } from '@sravni/react-seo';

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { ReviewsListParams } from '../../__generated__/reviews/reviewsApiTypes';
import { getReviews } from '../../services/reviews';

export interface IState {
  list: IReviewItem[];
}

export const fetchReviews = createAsyncThunk<IReviewItem[], ReviewsListParams>('reviews/fetch', async (params) =>
  getReviews(params),
);

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState: {
    list: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchReviews.fulfilled, (state, { payload }) => {
      state.list = payload;
    });
    builder.addCase(fetchReviews.rejected, (state) => {
      state.list = [];
    });
  },
});

const { reducer } = reviewsSlice;
export default reducer;
